<script lang="ts">
import { defineComponent } from 'vue';
import Company from '@/domain/model/business/Company';
import YieldPromiseStatus from '@/domain/model/business/YieldPromiseStatus.ts';
import Energy from '@/domain/model/unit/Energy.ts';
import { sendDialogOpenEvent } from '@/infrastructure/support/Analytics.ts';
import LongTermGapFillModal from '@/presentation/pages/plants/modals/LongTermGapFillModal.vue';
import PlantContactDialog from '@/presentation/pages/plants/modals/PlantContactDialog.vue';

export default defineComponent({
  name: 'LongTermGapFillsSection',
  components: { LongTermGapFillModal, PlantContactDialog },
  emits: ['fetch-required'],
  props: {
    company: { type: Company, required: true },
    period: { type: YieldPromiseStatus, required: true },
  },
  data() {
    return {
      dialogIsOpen: false,
    };
  },
  methods: {
    handleDialogOpen() {
      this.dialogIsOpen = true;
      sendDialogOpenEvent('single_plant', 'gap_fills');
    },
  },
  computed: {
    totalYieldFilled(): Energy {
      const totalYieldFilled = this.period
        .getActiveGapFills()
        .reduce((sum, gap) => sum + gap.yield_filled_in_wh, 0);

      return Energy.ofWh(totalYieldFilled);
    },
  },
});
</script>

<template>
  <div class="mt-4">
    <p class="text-muted">
      {{ $t('features.long_term.gap_fills.gap_fill', 2) }}
    </p>

    <span> {{ $t('features.long_term.gap_fills.intro') }} {{}} </span>
    <span v-if="period.getActiveGapFills().length === 0">
      {{ $t('features.long_term.gap_fills.gap_fills_none_created') }}
    </span>

    <span v-else>
      <i18n-t keypath="features.long_term.gap_fills.gap_fills_created_wh">
        <template #yield>
          <strong>
            {{ totalYieldFilled.toString() }}
          </strong>
        </template>
      </i18n-t>
    </span>

    <br />

    <Button @click="handleDialogOpen" outlined class="mt-2">
      {{ $t('features.long_term.gap_fills.button_add_view') }}
      <font-awesome-icon icon="arrow-up-right-from-square" class="ml-2" />
    </Button>

    <long-term-gap-fill-modal
      :id="period.getId()"
      v-if="period"
      v-model:visible="dialogIsOpen"
      :company="company"
      :period="period"
      @fetch-required="$emit('fetch-required')"
    />
  </div>
</template>

<style scoped></style>
